<template>
  <div class="item-element" :class="{upcase: upcase}">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    upcase: {
      type: Boolean,
      default: false
    }
  }
}


</script>

<style lang="scss" scoped>
  @use "~friendship_styles/colors" as colors;

  .item-element {
    color: colors.$dark-gray-text-color;
    padding: 14px 0 14px 0;
    border-bottom: 1px solid colors.$widget-background-light-gray;
    cursor: pointer;
  }

  .upcase {
    text-transform: uppercase;
  }

</style>
